<mat-button-toggle-group class="active-inactive-toggle" fxFlex="100">
  <mat-button-toggle data-testid="active-toggle" fxFlex="50" [disabled]="disabled" [checked]="!inactive" (click)="setInactive(false)">
    {{ activeLabel }}
  </mat-button-toggle>
  <mat-button-toggle data-testid="inactive-toggle" fxFlex="50" [disabled]="disabled" [checked]="inactive" (click)="setInactive(true)">
    {{ inactiveLabel }}
  </mat-button-toggle>
</mat-button-toggle-group>
